var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuItem, TextField } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { useController } from 'react-hook-form';
import { fetchMunicipios } from '../../services/localidades.service';
function isEstadoSiglaValido(sigla) {
    return sigla && typeof sigla === 'string' && sigla.trim() !== '';
}
var MunicipioSelect = function (_a) {
    var name = _a.name, control = _a.control, estadoSigla = _a.estadoSigla, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.required, required = _c === void 0 ? false : _c;
    var _d = useQuery({
        queryKey: ['municipios', estadoSigla],
        queryFn: function () { return fetchMunicipios(estadoSigla); },
        enabled: !!estadoSigla,
    }), municipios = _d.data, isLoading = _d.isLoading;
    var _e = useController({
        name: name,
        control: control,
    }), field = _e.field, error = _e.fieldState.error;
    useEffect(function () {
        if (isEstadoSiglaValido(previousEstadoSigla.current) &&
            previousEstadoSigla.current !== estadoSigla) {
            field.onChange({ target: { value: undefined, name: name } });
        }
        previousEstadoSigla.current = estadoSigla;
    }, [estadoSigla]);
    var previousEstadoSigla = useRef(estadoSigla);
    return (_jsxs(TextField, __assign({}, field, { "data-testid": name, select: true, label: !estadoSigla ? 'Selecione um estado primeiro' : 'Município', variant: "outlined", fullWidth: true, margin: "normal", required: !disabled && required, error: !!error, helperText: error ? error.message : '', disabled: disabled || isLoading || !estadoSigla, children: [_jsx(MenuItem, { value: undefined, children: !estadoSigla
                    ? 'Selecione um estado para listar os municípios'
                    : 'Selecione o município' }), municipios === null || municipios === void 0 ? void 0 : municipios.map(function (municipio) { return (_jsx(MenuItem, { value: municipio.id, children: municipio.nome }, municipio.id)); })] })));
};
export default MunicipioSelect;
